/**
 * Runtime configuration for the admin SPA.
 *
 * A Create React App build normally freezes REACT_APP_* values into the
 * bundle at `npm run build` time. That is the wrong shape here: it would mean
 * the configuration lives inside the image, one image per environment, and
 * changing an endpoint would require a rebuild.
 *
 * Instead the container's entrypoint reads the mounted .env at startup and
 * writes env-config.js, which sets `window.__ENV__` before the bundle loads.
 * nginx serves it at /env-config.js from a tmpfs (the container's root
 * filesystem is read-only). One image, configuration supplied at run time from
 * the .env file - the same contract the API follows.
 *
 * Resolution order, first hit wins:
 *   1. window.__ENV__       - injected from .env by the container at startup
 *   2. process.env.REACT_APP_*  - `npm start` during local development
 *   3. the fallback passed in   - so a missing value degrades, not crashes
 */

const runtime = (typeof window !== "undefined" && window.__ENV__) || {};

export function env(key, fallback = "") {
  const fromRuntime = runtime[key];
  if (typeof fromRuntime === "string" && fromRuntime !== "" && !fromRuntime.startsWith("__")) {
    return fromRuntime;
  }

  const fromBuild = process.env[key];
  if (typeof fromBuild === "string" && fromBuild !== "") return fromBuild;

  return fallback;
}
